import { AfterViewInit, Component, NgZone, OnInit } from "@angular/core"
import { OktaService } from "app/okta/okta.service"
import { UserDetailsService, UserDetailsWire } from 'app/shared/user-details.service'
import { ResourceService } from 'app/shared/resources/resource.service'
import { CookieService } from 'app/shared/cookie.service'
import { LayoutState } from 'app/shared/layout/layout-state'
import { OktaState } from 'app/okta/okta-state'
import { ChangeDetectorRef } from '@angular/core'
import { Router } from '@angular/router'
import { FormControl } from '@angular/forms'

@Component({
    selector: "sbw-menu",
    styleUrls: ["./menu.component.css"],
    templateUrl: "./menu.component.html",
})
export class MenuComponent implements OnInit, AfterViewInit {
    public userDetailsWire: UserDetailsWire
    public serviceLinks: CustomerService = {}
    public username: string
    public user: FormControl;

    public isLoggedIn: boolean
    public agentPage: boolean = window.location.pathname.includes('/agent/account/login')
    public oktaLoaded: boolean = false

    constructor(
        private userDetailsService: UserDetailsService,
        private resourceService: ResourceService,
        private oktaService: OktaService,
        private ref: ChangeDetectorRef,
        private ngZone: NgZone,
        private router: Router,
        private oktaState: OktaState,
        private cookieService: CookieService,
    ) { }

    ngOnInit() {
        this.user = new FormControl(null)
        this.resourceService.loadResources('Default', this.resourceService.getLocale(), ['Menu']);
        this.userDetailsService.getUserDetails().subscribe(data => {
            this.userDetailsWire = data
            this.oktaService.checkLoginType(this.userDetailsWire.authType)
        })

        this.resourceService.get('ONLINE_HELP_LINK', false, 'Menu').subscribe(resource => {
            this.serviceLinks.onlineHelp = resource
        })

        this.resourceService.get('SUPPORT_PHONE_NUMBER', false, 'Menu').subscribe(resource => {
            if (/\d/.test(resource)) this.serviceLinks.contact = resource
        })
    }

    ngAfterViewInit(): void {
        this.oktaState.isLoggedIn$.subscribe(user => {
            this.oktaState.isLoaded$.subscribe(val => {
                if (val) {
                    this.ngZone.run(() => {
                        this.oktaLoaded = true
                        this.user.patchValue(user)
                        this.username = user
                    })
                }
            })
        })
    }

    getReturnUrl(): string {
        return encodeURIComponent(location.pathname + location.search);
    }

    getLoginLink() {
        return `/_mvc/booking/account/login?returnUrl=${this.getReturnUrl()}`
    }

    getLogoutLink() {
        if (this.userDetailsWire.isAgent) {
            const salesOwnerId = this.cookieService.getCookie("sbw_SalesOwner")
            return `/agent/account/logout?salesOwnerId=${salesOwnerId}`
        }
        let returnUrl = 'https://www.dfds.com'
        if (location.host.includes('ferry.dfds.com')) {
            returnUrl = location.origin
        }
        else if (location.pathname.split('/').length > 3) {
            const pathParts = location.pathname.split('/')
            returnUrl = `${location.origin}/${pathParts[1]}/${pathParts[2]}/${pathParts[3]}`
        }
        return `/_mvc/booking/account/logout?returnUrl=${returnUrl}`
    }
}

export interface CustomerService {
    onlineHelp?: string
    contact?: string
}
